import Splide from '@splidejs/splide';
// import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { waveLineMv } from '@/pages/home/waveLineMv';

import { siteConfig } from '@/configs/siteConfig';

import { siteState } from '@/modules/siteState/siteStateGetter';

// const props = {
// } as const;

export const splideManager = {
  init() {
    this.home();
    this.contentBiz();
    this.transitEvent();
    this.relatedWorks();
    this.oscFlow();
  },

  home() {
    const elMv = document.getElementById('js-splideHomeMv');
    if (elMv) {
      const optionsMv = {
        type: 'fade',
        rewind: true,
        speed: 800,
        interval: 18000,
        autoplay: true,
        arrows: false,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
      };
      const sliderMv = new Splide(elMv, optionsMv);

      sliderMv.on('ready', function () {
        updateActiveCanvases();
      });

      // 内部スライダーの設定と初期化
      const optionsSub = {
        type: 'fade',
        rewind: false,
        speed: 1200,
        interval: 6000,
        autoplay: true,
        arrows: false,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
      };
      const subSliderEls = document.querySelectorAll('.js-splideHomeSub');
      const subSliderInsts = Array.from(subSliderEls).map((slider) => {
        return new Splide(slider as HTMLElement, optionsSub);
      });

      // 内部スライダーをマウント
      subSliderInsts.forEach((slider) => {
        slider.mount();

        slider.on('moved', () => {
          updateActiveCanvases();
        });
      });

      // ボタンリストを取得
      const btnElms = document.querySelectorAll('#js-splideHomeMvBtnList > *');

      btnElms.forEach((btn, index) => {
        btn.addEventListener('mouseenter', () => {
          if (siteState.winWidth >= siteConfig.breakpoint.shiftPoint) {
            sliderMv.go(index);
            sliderMv.emit('moved', index);
            sliderMv.Components.Autoplay.pause();
            sliderMv.Components.Autoplay.play();
          }
        });
      });

      sliderMv.on('moved', (newIndex: number) => {
        // hover中なら強制的にスライドを戻す（必要なら）
        const hoveredIndex = Array.from(btnElms).findIndex((btn) => btn.matches(':hover'));
        if (hoveredIndex !== -1 && newIndex !== hoveredIndex) {
          sliderMv.go(hoveredIndex);
          sliderMv.Components.Autoplay.pause();
          sliderMv.Components.Autoplay.play();
        } else {
          updateActiveClass(newIndex);
        }

        subSliderInsts[newIndex].go(0);
        subSliderInsts[newIndex].Components.Autoplay.pause();
        subSliderInsts[newIndex].Components.Autoplay.play();

        updateActiveCanvases();
      });

      const progressBarElms = document.querySelectorAll<HTMLElement>('.p-homeMv__btnProgress');
      sliderMv.on('autoplay:playing', (rate: number) => {
        progressBarElms.forEach((bar) => (bar.style.width = `${rate * 100}%`));
      });

      sliderMv.mount();
      updateActiveClass(0);

      function updateActiveClass(newIndex: number) {
        // まず全てのボタンから is-active を削除
        btnElms.forEach((btn) => btn.classList.remove('is-active'));

        // 現在のスライドと同じインデックスのボタンに is-active を追加
        const currentBtn = btnElms[newIndex];
        if (currentBtn) currentBtn.classList.add('is-active');
      }

      /**
       * アクティブなスライド内のcanvasにマーカーを付ける
       */
      function updateActiveCanvases() {
        const allCanvases = document.querySelectorAll<HTMLCanvasElement>('.js-canvasHomeMv');

        allCanvases.forEach((canvas) => {
          // 親スライドがis-activeを持っているか
          const parentSlide = canvas.closest('.p-homeMvSlide__slide');
          const isParentActive = parentSlide?.classList.contains('is-active');

          // 子スライドがis-activeを持っているか
          const childSlide = canvas.closest('.p-homeSubSlide__slide');
          const isChildActive = childSlide?.classList.contains('is-active');

          // 両方がアクティブな場合のみ data-active を付ける
          if (isParentActive && isChildActive) {
            canvas.dataset.active = 'true';
          } else {
            delete canvas.dataset.active;
          }
        });

        // ★ waveLineMvに状態変更を通知
        if (waveLineMv && typeof waveLineMv.updateActiveStates === 'function') {
          waveLineMv.updateActiveStates();
        }
      }
    }
  },

  contentBiz() {
    const el = document.getElementById('js-splideContentBizMovie');
    if (el) {
      const options = {
        type: 'loop',
        autoplay: false,
        gap: '4rem',
        arrows: true,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          1024: {
            gap: '2rem',
          },
        },
      };
      const slider = new Splide(el, options);
      const bar = slider.root.querySelector('.p-contentMovieSlide__progressBar') as HTMLElement | null;

      // is-current の付け替え処理を共通化
      const updateCurrentClass = () => {
        const slides = slider.Components.Elements.slides;

        // いったん全て外す
        slides.forEach((slide) => slide.classList.remove('is-current'));

        // 現在の index のスライドに付与
        const currentSlide = slides[slider.index];
        if (currentSlide) currentSlide.classList.add('is-current');
      };

      // ===========================================
      // YouTube IFrame API 関連
      // ===========================================
      function loadYouTubeAPI(): Promise<void> {
        return new Promise((resolve) => {
          // すでに読み込み済みなら何もしない
          if (document.getElementById('youtube-iframe-api')) {
            resolve();
            return;
          }

          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          tag.id = 'youtube-iframe-api';
          document.body.appendChild(tag);

          // API が ready になったら resolve
          (window as any).onYouTubeIframeAPIReady = () => {
            resolve();
          };
        });
      }

      const players = new Map<string, YT.Player>();

      function initYouTubePlayers() {
        const iframes = document.querySelectorAll<HTMLIFrameElement>('.p-contentMovieSlide__videoFrame iframe');

        iframes.forEach((iframe, index) => {
          const id = iframe.dataset.playerId || `video-${index}`;
          iframe.dataset.playerId = id;

          const player = new YT.Player(iframe, {
            events: {
              onReady: () => {
                console.log(`Player ready: ${id}`);
              },
            },
          });

          players.set(id, player);
        });
      }

      document.addEventListener('click', (e: MouseEvent) => {
        const target = e.target as HTMLElement | null;
        if (!target) return;

        const btn = target.closest('.p-contentMovieSlide__videoBtn') as HTMLElement | null;
        if (!btn) return;

        // どのスライドでクリックされたか？
        const slide = btn.closest('.splide__slide') as HTMLElement | null;
        if (!slide) return;

        // Swiper が持っている実際の index
        const slideIndex = slide.getAttribute('data-slide-index');
        if (slideIndex == null) return;

        // 対象となるスライド（実スライド＋複製スライド）
        const siblingSlides = document.querySelectorAll<HTMLElement>(`.splide__slide[data-slide-index="${slideIndex}"]`);

        siblingSlides.forEach((s) => {
          const videoFrame = s.querySelector('.p-contentMovieSlide__videoFrame') as HTMLElement | null;
          if (!videoFrame) return;

          const iframe = videoFrame.querySelector('iframe') as HTMLIFrameElement | null;
          if (!iframe) return;

          const id = iframe.dataset.playerId!;
          const player = players.get(id);
          if (!player) return;

          // それぞれのスライド内のボタンを消す
          const btnInSlide = s.querySelector('.p-contentMovieSlide__videoBtn');
          btnInSlide?.remove();

          // API 再生
          if (s.closest('.is-current')) {
            player.playVideo();
          }
        });
      });

      function stopAllVideos() {
        players.forEach((player) => {
          player.pauseVideo(); // ← API 制御なので確実に停止！
        });
      }

      // ===========================================
      // スライダーのイベント処理
      // ===========================================
      slider.on('mounted move', () => {
        updateCurrentClass();
        stopAllVideos();

        if (bar) {
          const end = slider.Components.Controller.getEnd() + 1;
          const rate = Math.min((slider.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        }
      });

      slider.on('mounted', () => {
        (async () => {
          await loadYouTubeAPI(); // API を読み込む
          initYouTubePlayers(); // 全 iframe をプレイヤー化
        })();
      });

      // ===========================================
      // スライダーの初期化
      // ===========================================
      slider.mount();
    }
  },

  transitEvent() {
    const el = document.getElementById('js-splideTransitEvent');
    if (el) {
      const options = {
        type: 'slide',
        autoplay: false,
        gap: '4rem',
        arrows: true,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          1024: {
            gap: '3rem',
            autoWidth: true,
            focus: 0,
            omitEnd: true,
          },
        },
      };
      const slider = new Splide(el, options);
      const bar = slider.root.querySelector('.p-transitEventSlide__progressBar') as HTMLElement | null;

      // ===========================================
      // スライダーのイベント処理
      // ===========================================
      slider.on('mounted move', () => {
        if (bar) {
          const end = slider.Components.Controller.getEnd() + 1;
          const rate = Math.min((slider.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        }
      });

      slider.on('mounted move resized', () => {});

      // ===========================================
      // スライダーの初期化
      // ===========================================
      slider.mount();
    }
  },

  relatedWorks() {
    const el = document.getElementById('js-splideRelatedWorks');
    if (el) {
      const options = {
        type: 'slide',
        autoplay: false,
        gap: '3.5rem',
        autoWidth: true,
        focus: 0,
        omitEnd: true,
        arrows: true,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
          1024: {
            gap: '3rem',
          },
        },
      };
      const slider = new Splide(el, options);
      const bar = slider.root.querySelector('.p-worksSingleRelatedSlide__progressBar') as HTMLElement | null;

      // ===========================================
      // スライダーのイベント処理
      // ===========================================
      slider.on('mounted move', () => {
        if (bar) {
          const end = slider.Components.Controller.getEnd() + 1;
          const rate = Math.min((slider.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        }
      });

      slider.on('mounted move resized', () => {});

      // ===========================================
      // スライダーの初期化
      // ===========================================
      slider.mount();
    }
  },

  oscFlow() {
    const el = document.getElementById('js-splideOscFlow');
    if (el) {
      const options = {
        type: 'slide',
        autoplay: false,
        gap: '2.5rem',
        arrows: true,
        pagination: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoWidth: true,
        focus: 0,
        omitEnd: true,
        breakpoints: {
          1024: {
            gap: '1.6rem',
          },
        },
      };
      const slider = new Splide(el, options);
      const bar = slider.root.querySelector('.p-oscListSlide__progressBar') as HTMLElement | null;

      // ===========================================
      // スライダーのイベント処理
      // ===========================================
      slider.on('mounted move', () => {
        if (bar) {
          const end = slider.Components.Controller.getEnd() + 1;
          const rate = Math.min((slider.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        }
      });

      slider.on('mounted move resized', () => {});

      // ===========================================
      // スライダーの初期化
      // ===========================================
      slider.mount();
    }
  },
};
